import { useState } from 'react';
import { getAuth } from 'firebase/auth';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';

const AiAnalyse = () => {
  const [image, setImage] = useState(null);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [price, setPrice] = useState('');
  const [mileage, setMileage] = useState('');
  const [serviced, setServiced] = useState('');
  const [accident, setAccident] = useState('');
  const [lastChanges, setLastChanges] = useState('');
  const [lastBigService, setLastBigService] = useState('');
  const [lastOilChange, setLastOilChange] = useState('');

  const handleUpload = async () => {
    if (!image) {
      setError('Ве молам изберете слика');
      return;
    }

    setError(null);
    setResult(null);
    setIsLoading(true);

    try {
      const auth = getAuth();
      const user = auth.currentUser;

      if (!user) {
        throw new Error('Мора да сте најавени');
      }

      const storage = getStorage();
      const fileName = `ai-analysis/${Date.now()}_${image.name.replace(/\s+/g, '_')}`;
      const storageRef = ref(storage, fileName);

      await uploadBytes(storageRef, image);
      const downloadUrl = await getDownloadURL(storageRef);

      const token = await user.getIdToken();
      const response = await fetch(
        'https://us-central1-auto-makedonija.cloudfunctions.net/api/analyze-image',
        {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            imageUrl: downloadUrl,
            price,
            mileage,
            serviced,
            accident,
            lastChanges,
            lastBigService,
            lastOilChange
          })
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Грешка од серверот');
      }

      const data = await response.json();
      setResult(data);
    } catch (err) {
      console.error('Upload error:', err);
      setError(err.message || 'Грешка при комуникација со серверот');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="ai-analyse-wrapper">
      <h1 className="ai-title">AI Анализа на Возило</h1>

      <div className="ai-form">
        <label className="upload-label">
          {image ? image.name : 'Прикачи слика'}
          <input type="file" accept="image/*" onChange={(e) => setImage(e.target.files?.[0] || null)} />
        </label>

        <input type="text" placeholder="Цена (€)" value={price} onChange={(e) => setPrice(e.target.value)} />
        <input type="text" placeholder="Километража (km)" value={mileage} onChange={(e) => setMileage(e.target.value)} />
        <input type="text" placeholder="Редовно сервисирано? (да/не)" value={serviced} onChange={(e) => setServiced(e.target.value)} />
        <input type="text" placeholder="Имало судир? (да/не)" value={accident} onChange={(e) => setAccident(e.target.value)} />
        <input type="text" placeholder="Последно сменето" value={lastChanges} onChange={(e) => setLastChanges(e.target.value)} />
        <input type="text" placeholder="Голем сервис (да/не и кога)" value={lastBigService} onChange={(e) => setLastBigService(e.target.value)} />
        <input type="text" placeholder="Последна промена на масло" value={lastOilChange} onChange={(e) => setLastOilChange(e.target.value)} />

        <button onClick={handleUpload} disabled={isLoading} className="ai-upload-btn">
          {isLoading ? 'Анализира...' : 'Анализирај'}
        </button>

        {error && <p className="ai-error">{error}</p>}
      </div>

      {result && (
        <div className="ai-result">
          {result.imageUrl && <img src={result.imageUrl} alt="Резултат слика" className="ai-result-img" />}

          <div className="ai-result-text">
            <h2>Резултат од анализа</h2>
            <p>{result.analysis?.text || 'Нема податоци'}</p>
          </div>
        </div>
      )}

      <style jsx>{`
        .ai-analyse-wrapper {
          max-width: 900px;
          margin: auto;
          padding: 2rem;
          background: #0c0f1a;
          border-radius: 24px;
          color: #e0e0e0;
          font-family: 'Orbitron', sans-serif;
          box-shadow: 0 0 30px rgba(0, 255, 255, 0.3);
        }
        .ai-title {
          font-size: 2.5rem;
          color: #00ffff;
          text-align: center;
          margin-bottom: 2rem;
          text-shadow: 0 0 15px rgba(0, 255, 255, 0.6);
        }
        .ai-form {
          display: grid;
          gap: 1rem;
        }
        .upload-label {
          background: #1a1f2d;
          border: 2px dashed #00ffff;
          padding: 1.5rem;
          text-align: center;
          border-radius: 12px;
          cursor: pointer;
        }
        input[type="file"] {
          display: none;
        }
        input[type="text"] {
          padding: 0.8rem;
          background: #1a1f2d;
          border: none;
          border-radius: 8px;
          color: #00ffff;
        }
        .ai-upload-btn {
          background: #00ffff;
          color: #0c0f1a;
          padding: 1rem;
          border: none;
          border-radius: 50px;
          font-weight: bold;
          text-transform: uppercase;
          letter-spacing: 1px;
          cursor: pointer;
        }
        .ai-error {
          color: #ff5555;
          margin-top: 1rem;
        }
        .ai-result {
          margin-top: 2rem;
          padding: 2rem;
          background: rgba(0, 40, 40, 0.7);
          border-radius: 16px;
          border: 1px solid rgba(0, 255, 255, 0.3);
          box-shadow: 0 0 25px rgba(0, 255, 255, 0.2);
        }
        .ai-result-img {
          width: 100%;
          max-height: 400px;
          object-fit: contain;
          border-radius: 12px;
          margin-bottom: 1.5rem;
        }
        .ai-result-text h2 {
          color: #00ffff;
          font-size: 1.5rem;
          margin-bottom: 1rem;
        }
        .ai-result-text p {
          white-space: pre-wrap;
          line-height: 1.6;
          color: #e0ffff;
        }
      `}</style>
    </div>
  );
};

export default AiAnalyse;
